import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'

import { ChevronLeft } from 'lucide-react'
import backgroundMobile from 'src/assets/mobileBackground.png'
import appStore from 'src/assets/product-config/app-store.png'
import background from 'src/assets/product-config/background-signin.png'
import android from 'src/assets/product-config/google-play.png'

export const ChooseAccountType: React.FC = () => {
  const navigation = useNavigate()
  const { account, user } = useAuth()

  const [isMobile, setIsMobile] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    if (account) {
      navigation('/')
    }

    if (user?.type === 'GRAPHIC') {
      window.location.reload()
    }
  }, [account, user, navigation])

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 720)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  if (isMobile) {
    return (
      <div
        className="w-full h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundMobile}')`,
        }}
      />
    )
  }

  return (
    <div
      className="h-screen relative flex flex-row justify-between gap-5 "
      style={{
        backgroundImage: `url(${background})
		  `,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
    >
      <div className="flex flex-col absolute bottom-10 left-10">
        <span className="text-white text-xl font-bold">Baixe o nosso app,</span>
        <span className="text-white text-xl">
          disponível nas principais lojas
        </span>
        <div className="flex gap-2 mt-2">
          <img
            alt=""
            src={android}
            className="w-[150px] object-contain cursor-pointer"
          />
          <img
            alt=""
            src={appStore}
            className="w-[150px] object-contain cursor-pointer"
          />
        </div>
      </div>
      <div className="flex-1 flex flex-col justify-center items-end">
        <div className="flex h-full w-[40%] items-center p-24 justify-center">
          <div
            onSubmit={() => {}}
            className="flex relative flex-col gap-4 w-full items-center bg-black bg-opacity-40 rounded-3xl p-16 backdrop-filter backdrop-blur-md border border-gray-600"
          >
            <ChevronLeft
              onClick={() => {
                navigate('/create-account-wallet')
              }}
              className="absolute top-6 left-6 cursor-pointer"
              size={30}
              color="white"
            />
            <span className="text-white font-bold text-3xl">
              É hora de escolher o tipo da sua conta
            </span>
            <span className="text-white text-xl">
              Decida se deseja uma conta Wallet comercial ou pessoal.
            </span>

            <button
              onClick={() =>
                navigate('/create-account-wallet/insert-data', {
                  state: { accountType: 'PF' },
                })
              }
              className="w-full bg-gradient-to-r from-white via-zinc-200 to-white text-zinc-900 font-semibold rounded-md border-zinc-400 border h-16 mt-2"
            >
              Conta Física
            </button>
            <button
              onClick={() =>
                navigate('/create-account-wallet/insert-data-pj', {
                  state: { accountType: 'PJ' },
                })
              }
              className="w-full bg-gradient-to-r from-zinc-950 via-zinc-700 to-zinc-950 text-white font-semibold rounded-md border-zinc-400 border h-16 mt-2"
            >
              Conta Business
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
